<template lang="pug">
    .entity
        .entity__text Введите ИНН, и мы автоматически заполним часть данных, чтобы ускорить процесс.
        form.form
            .form__group
                label.form__label ИНН
                input(type='text' v-model="value" @input="onlyNumber(value)").form__input
                span.form__info
                    svgicon(name=`info` :fill="false")
                    .form__info-hidden Если кто-то захочет остановить обработку своих персональных данных, он свяжется с вами по указанным данным
            .entity__title Регистрационные данные
            .entity__title-mini ФИО индивидуального предпринимателя
            .form__flex
                .form__group.form__group--mini
                    label.form__label Фамилия
                    input(type="text").form__input
                .form__group.form__group--mini
                    label.form__label Имя
                    input(type="text").form__input
                .form__group.form__group--mini
                    label.form__label Отчество
                    input(type="text").form__input

            .form__group.form__group--mini
                label.form__label ОГРНИП
                input(type="text").form__input

            .form__group.form__group--big
                label.form__label Почтовый адрес
                input(type="text").form__input
            .form__group.form__group--big
                label.form__label Фактический адрес
                input(type="text").form__input

            .entity__title-mini Информация об НДС
            .form__group
                p-radio(name="nds" class="input-round p-svg p-round p-pulse wrap-text" color="primary" checked="checked")
                    svgicon(name="check" class="svg")
                    |Упрощенная система налогообложения (Доход)
            .form__group
                p-radio(name="nds" class="input-round p-svg p-round p-pulse wrap-text" color="primary")
                    svgicon(name="check" class="svg")
                    |Упрощенная система налогообложения (Доход минус Расход)
            .form__group
                p-radio(name="nds" class="input-round p-svg p-round p-pulse wrap-text" color="primary")
                    svgicon(name="check" class="svg")
                    |Общая система налогообложения (с НДС)
            .entity__title Персональные данные
            .entity__title-mini Данные паспорта
            .form__flex
                .form__group.form__group--mini
                    label.form__label Серия
                    input(type="text").form__input
                .form__group.form__group--mini
                    label.form__label Номер
                    input(type="text").form__input
                .form__group.form__group--mini
                    label.form__label Дата выдачи документа
                    date-picker(v-model="documentDate" format="DD.MM.YYYY").form__input
            .form__group.form__group--big
                label.form__label Наименование органа, выдавшего документ
                input(type="text").form__input
            .form__group.form__group--big
                label.form__label Код подразделения
                input(type="text").form__input
            .form__group.form__group--mini
                label.form__label Дата рождения
                date-picker(v-model="birthday" format="DD.MM.YYYY").form__input
            .form__group.form__group--big
                label.form__label Место рождения
                input(type="text").form__input
                

            .entity__title Банковские реквизиты
            .entity__title-mini Введите БИК, и мы автоматически заполним поля к/с и наименование банка,
                br
                | чтобы ускорить процесс регистрации.
            .form__group.form__group--big
                label.form__label БИК банка
                input(type="text").form__input
            .form__group.form__group--big
                label.form__label Корреспондентский счет
                input(type="text").form__input
            .form__group.form__group--big
                label.form__label Наименование банка
                input(type="text").form__input
            .form__group.form__group--big
                label.form__label Расчётный счёт
                input(type="text").form__input
            .form__group
                p-check(name="pers" class="input-round p-svg p-round p-pulse wrap-text" color="primary")
                    svgicon(name="check" class="svg")
                    |Даю согласие на обработку
                    a(href="#") персональных данных
            button.btn.btn--big Сохранить
</template>

<script>
export default {
  name: 'indent',
  data() {
    return {
      value: null,
      birthday: null,
      documentDate: null,
    }
  },
  methods: {
    onlyNumber(value){
      return this.value = value.replace(/[^\d]/g,'');
    }
  }
}
</script>

<style lang="scss">
  
</style>
